import React from "react";
import { createRoot } from 'react-dom/client';
import '../../styles/components/store-locator-drawer.scss';
import { StoreLocatorDrawer } from "../react_components/StoreLocatorDrawer.js";
import { APIProvider } from '@vis.gl/react-google-maps';

const rootElements = Array.from(document.querySelectorAll('[data-store-locator-drawer]'));

// creates the roots to render the react components
if (rootElements.length > 0) {
  rootElements.forEach(rootEl => {
    const root = createRoot(rootEl);
    if (root) {
      root.render(
        <APIProvider apiKey={rootEl.dataset.storeLocatorDrawer}>
          <StoreLocatorDrawer />
        </APIProvider>
      );
      rootEl._reactRootContainer = root;
    }
    window.resizeTo(window.innerWidth, window.innerHeight);
  });
}
